import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import FlexGrid from "@tds/core-flex-grid";
import Box from "@tds/core-box";
import { colorGreyShark, colorWhite } from "@tds/core-colours";
import Text from "@tds/core-text";

function Footer({ logo, t }) {
  return (
    <div
      style={{ background: colorGreyShark, color: colorWhite }}
      className="footer"
    >
      <FlexGrid>
        <FlexGrid.Row>
          <FlexGrid.Col horizontalAlign={{ xs: "center", md: "left" }}>
            <Box inline vertical={4} between={4} verticalAlign="middle">
              <img
                style={{ height: "28px" }}
                alt={t("telusLogoFooter")}
                src={logo}
              />
            </Box>
          </FlexGrid.Col>
          <FlexGrid.Col horizontalAlign="right">
            <Box inline vertical={4}>
              <Text>
                <span style={{ color: colorWhite }}>
                  ©{new Date().getFullYear()} TELUS
                </span>
              </Text>
            </Box>
          </FlexGrid.Col>
        </FlexGrid.Row>
      </FlexGrid>
    </div>
  );
}

Footer.propTypes = {
  logo: PropTypes.string,
  t: PropTypes.func.isRequired,
};

Footer.defaultProps = {
  logo: "https://static.telus.com/common/images/footer/TELUS-logo-white.svg",
};

export default withTranslation()(Footer);
